/**
 * Platform edge payloads (`platform-list-tenant-members`,
 * `platform-list-platform-users`) may carry a top-level
 * `last_sign_in_unavailable: true` when the server could not read sign-ins.
 * Stamp it onto each row so the (presentational) row can render "—" instead of
 * "Never". Returns the SAME array when the flag is absent (no identity churn).
 */
export function withLastSignInFlag(list, payload) {
  const rows = list || [];
  if (payload?.last_sign_in_unavailable !== true) return rows;
  return rows.map((r) => ({ ...r, last_sign_in_unavailable: true }));
}

/**
 * Value for `LastSignInText` from a platform edge row: `undefined` ("—") when
 * the server flagged the read unavailable or the field is absent (older
 * deploy), `null` = joined and never signed in, else the timestamp.
 */
export function platformLastSignInValue(row) {
  if (!row || row.last_sign_in_unavailable === true) return undefined;
  if (!Object.prototype.hasOwnProperty.call(row, 'last_sign_in_at')) return undefined;
  return row.last_sign_in_at ?? null;
}
